var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-container"},[_c('h3',[_vm._v(_vm._s(_vm.$t('record_not_found')))]),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.$t('go-back'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }